module.exports = __webpack_public_path__ + "assets/e83740f639e265b08f974121c2bd3b3a.mp4";